// frontend/src/utils/serviceLevel.js
//
// The service-level bound, and the only place the frontend states it.
//
// `ItemLocation.ServiceLevelPct` is `DecimalField(max_digits=5,
// decimal_places=2)` constrained to the OPEN interval (0, 100) by
// `item_location_service_level_pct_range` (backend/api/models.py) — it is a
// probability, and 100% has an infinite z-score while 0% has a
// negative-infinite one. At two decimal places the representable edges of that
// interval are 0.01 and 99.99, which is exactly what the DRF field declares
// (backend/api/serializers.py).

export const SERVICE_LEVEL_MIN = 0.01;
export const SERVICE_LEVEL_MAX = 99.99;

/** `decimal_places=2` on the column. */
export const SERVICE_LEVEL_DECIMALS = 2;

/**
 * Is `n` a service level the server will accept?
 *
 * Takes a NUMBER, not a raw input string: the caller parses in the merchant's
 * locale first.
 *
 * @param {number} n
 * @returns {boolean}
 */
export function serviceLevelInRange(n) {
  return Number.isFinite(n) && n >= SERVICE_LEVEL_MIN && n <= SERVICE_LEVEL_MAX;
}

/**
 * `n` at the two decimal places the column stores.
 *
 * Callers that round MUST check `serviceLevelInRange` on the ROUNDED value —
 * rounding can carry a number that was inside the open interval (0, 100) out of
 * the representable range (99.995 rounds to 100.00, 0.001 to 0.00), and the
 * serializer refuses both.
 *
 * @param {number} n
 * @returns {number}
 */
export function roundServiceLevel(n) {
  const scale = 10 ** SERVICE_LEVEL_DECIMALS;
  return Math.round(n * scale) / scale;
}
